/** Words and small numbers for the Overview page. Pure. */
import { type OverviewDay } from '@lsc/contract';

/** "$0.03", "$1.40"; under a cent reads as "under 1 cent" so a real spend never shows as $0.00. */
export function usd(n: number): string {
  if (n === 0) return '$0.00';
  if (n < 0.005) return 'under 1 cent';
  return `$${n.toFixed(2)}`;
}

/** Hours to a phrase a rep reads: "40 minutes", "3 hours", "1.5 days". */
export function durationWords(hours: number | null): string {
  if (hours === null) return 'no closes yet';
  if (hours < 1) return `${String(Math.max(1, Math.round(hours * 60)))} minutes`;
  if (hours < 48) return `${String(Math.round(hours))} ${Math.round(hours) === 1 ? 'hour' : 'hours'}`;
  const days = Math.round((hours / 24) * 10) / 10;
  return `${String(days)} days`;
}

/** "3 weeks", "4 days", "6 hours" since an ISO moment. */
export function ageWords(iso: string | null, now: Date = new Date()): string | null {
  if (!iso) return null;
  const h = (now.getTime() - new Date(iso).getTime()) / 3600_000;
  if (h < 1) return 'under an hour';
  if (h < 24) return `${String(Math.round(h))} ${Math.round(h) === 1 ? 'hour' : 'hours'}`;
  const d = Math.round(h / 24);
  if (d < 14) return `${String(d)} ${d === 1 ? 'day' : 'days'}`;
  const w = Math.round(d / 7);
  return `${String(w)} ${w === 1 ? 'week' : 'weeks'}`;
}

/** "Mon 19" for a YYYY-MM-DD day label under a bar. */
export function dayLabel(day: string): string {
  const d = new Date(`${day}T12:00:00Z`);
  return `${d.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' })} ${String(d.getUTCDate())}`;
}

/** A shared top for the two ticket charts, so opened and closed read on one scale. */
export function sharedMax(days: OverviewDay[]): number {
  return Math.max(1, ...days.map((d) => Math.max(d.opened, d.closed)));
}

export const TRIGGER_WORDS: Record<string, string> = { open: 'Opening a ticket', manual: 'Update button' };
